import { useEffect, useRef } from "react";
import L from "leaflet";

export function LiveMap({ points = [] }) {
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current) {
      mapRef.current = L.map("live-map", { zoomControl: true, attributionControl: true })
        .setView([9.082, 8.6753], 6);
      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19, attribution: "© OpenStreetMap contributors",
      }).addTo(mapRef.current);
      layerRef.current = L.layerGroup().addTo(mapRef.current);
    }
    const layer = layerRef.current;
    if (!layer) return;
    layer.clearLayers();
    points.forEach((p) => {
      if (p.lat == null || p.lng == null) return;
      const color = p.is_user ? "#10B981" : "#F59E0B";
      const marker = L.circleMarker([p.lat, p.lng], {
        radius: 8, color, fillColor: color, fillOpacity: 0.7, weight: 2,
      });
      marker.bindPopup(
        `<b>${p.is_user ? p.user_name || "Registered user" : "Visitor"}</b><br/>` +
        `${p.city || "Unknown"}, ${p.state || ""}<br/>` +
        `<span style="color:#71717a">${p.path || "/"}</span>`
      );
      marker.addTo(layer);
    });
  }, [points]);

  useEffect(() => () => {
    if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; layerRef.current = null; }
  }, []);

  return <div id="live-map" style={{ height: 440 }} className="w-full rounded-3xl overflow-hidden border border-zinc-200 z-0" />;
}
